import fetch from '../../utils/fetch';
import { API_ROUTES } from '../../utils/constants';
import { getUserToken } from '../../utils/helpers';

export const getAllReportAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: `${API_ROUTES.CHART_REPORT}`, params, requestHeaders: headers, basic: false,
  });
};

export const getChartReportAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: `${API_ROUTES.CHART_REPORT}`, params, requestHeaders: headers, basic: false,
  });
};

export const getTableReportAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const { appId, isAdmin } = data;
  const params = {
    from: data.from,
    to: data.to,
  };

  const route = isAdmin ? `${API_ROUTES.CREATE_APP}/${appId}/${API_ROUTES.ADMIN_TABLE_REPORT}` : `${API_ROUTES.CREATE_APP}/${appId}/${API_ROUTES.TABLE_REPORT}`;

  return fetch({
    method: 'GET', route, params, requestHeaders: headers, basic: false,
  });
};


export const getExportAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    Accept: '*/* ',
    Authorization: `Bearer ${accessToken}`,

  };
  return fetch({
    method: 'GET', route: `${API_ROUTES.EXPORT}`, params, responseType: 'blob', requestHeaders: headers, basic: false,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard/api.js